import { YearlyReport, BudgetPreSanction, Summary, SummaryYearly } from "../Components/index.js";

export default [
    {
        path: "/reports/account/yearly-report",
        component: YearlyReport,
        name: "report.account.budget.yearly",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/income-expense-summary",
        component: Summary,
        name: "report.account.budget.summary",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/income-expense-yearly",
        component: SummaryYearly,
        name: "report.account.income.expense.yearly",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/budget-presanction/:id",
        component: BudgetPreSanction,
        name: "report.account.budget.PreSanction",
        meta: {
            requiresAuth: true,
        },
    },
];
